import { css } from "emotion";
import moment from "moment";
import numeral from "numeral";
import {
  DocumentCard,
  DocumentCardLocation,
  DocumentCardPreview,
  DocumentCardTitle,
  IDocumentCardPreviewProps,
  Label,
} from "office-ui-fabric-react";
import React from "react";
import { Assign, Employee, Job, NenkiInfo } from "../../../../types/types";
import { formatComma } from "../../../../util/util";
import { EmployeeDetail } from "../employee-detail/EmployeeDetail";

export interface SidePanelProps {
  nenkiInfo: NenkiInfo;
  employee?: Employee;
  selectedJob?: Job;
  sagyoKosu?: number;
  selectedJobAssignSummary: any;
  assigns?: Assign[];
}

const documentCardStyle = css`
  width: 25vw;
`;

export const SidePanel = ({
  nenkiInfo,
  employee,
  selectedJob,
  sagyoKosu,
  selectedJobAssignSummary,
  assigns,
}: SidePanelProps) => {
  if (!selectedJob) {
    return <DocumentCard className={documentCardStyle} />;
  }

  return (
    <DocumentCard className={documentCardStyle}>
      <EmployeeDetail
        nenkiInfo={nenkiInfo}
        employee={employee}
        assigns={assigns}
      />
      <DocumentCardPreview {...previewProps} />
      <DocumentCardLocation
        location={`${selectedJob.groupName} / ${selectedJob.clientName}`}
      />
      <DocumentCardTitle
        title={`${selectedJob.jobName}`}
        styles={{ root: { height: "70px" } }}
      />
      <div
        className={css`
          padding-left: 10px;
          padding-right: 10px;
        `}
      >
        <table>
          <tbody>
            <tr>
              <td
                className={css`
                  width: 120px;
                `}
              >
                <Label styles={{ root: { padding: 0 } }}>案件No</Label>
              </td>
              <td
                className={css`
                  text-align: right;
                `}
              >
                <Label styles={{ root: { padding: 0 } }}>
                  {selectedJob.jobNo}
                </Label>
              </td>
            </tr>
            <tr>
              <td
                className={css`
                  width: 120px;
                `}
              >
                <Label styles={{ root: { padding: 0 } }}>管理番号</Label>
              </td>
              <td
                className={css`
                  text-align: right;
                `}
              >
                <Label styles={{ root: { padding: 0 } }}>
                  {selectedJob.managementNo}
                </Label>
              </td>
            </tr>
            <tr>
              <td
                className={css`
                  width: 120px;
                `}
              >
                <Label styles={{ root: { padding: 0 } }}>受注ステータス</Label>
              </td>
              <td
                className={css`
                  text-align: right;
                `}
              >
                <Label styles={{ root: { padding: 0 } }}>
                  {selectedJob.kakudo}
                </Label>
              </td>
            </tr>
            <tr>
              <td
                className={css`
                  width: 120px;
                `}
              >
                <Label styles={{ root: { padding: 0 } }}>契約形態</Label>
              </td>
              <td
                className={css`
                  text-align: right;
                `}
              >
                <Label styles={{ root: { padding: 0 } }}>
                  {selectedJob.contractType}
                </Label>
              </td>
            </tr>
            <tr>
              <td
                className={css`
                  width: 120px;
                `}
              >
                <Label styles={{ root: { padding: 0 } }}>引合金額</Label>
              </td>
              <td
                className={css`
                  text-align: right;
                `}
              >
                <Label styles={{ root: { padding: 0 } }}>
                  {selectedJob.hikiai
                    ? `${formatComma(selectedJob.hikiai)}千円`
                    : "未設定"}
                </Label>
              </td>
            </tr>
            <tr>
              <td>
                <Label styles={{ root: { padding: 0 } }}>作業工数</Label>
              </td>
              <td
                className={css`
                  text-align: right;
                `}
              >
                <Label styles={{ root: { padding: 0 } }}>
                  {sagyoKosu ? numeral(sagyoKosu).format("0.00") : "-"}人月
                </Label>
              </td>
            </tr>
            <tr>
              <td>
                <Label styles={{ root: { padding: 0 } }}>アサイン予定</Label>
              </td>
              <td
                className={css`
                  text-align: right;
                `}
              >
                <Label styles={{ root: { padding: 0 } }}>
                  {numeral(selectedJobAssignSummary.total).format("0.00")}人月
                </Label>
              </td>
            </tr>
            <tr>
              <td>
                <Label styles={{ root: { padding: 0 } }}>案件作成者</Label>
              </td>
              <td
                className={css`
                  text-align: right;
                `}
              >
                <Label styles={{ root: { padding: 0 } }}>
                  {selectedJob.createdBy}
                </Label>
              </td>
            </tr>
            <tr>
              <td>
                <Label styles={{ root: { padding: 0 } }}>年期</Label>
              </td>
              <td
                className={css`
                  text-align: right;
                `}
              >
                <Label styles={{ root: { padding: 0 } }}>
                  {selectedJob.nenkiList.join(", ")}
                </Label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </DocumentCard>
  );
};

const previewProps: IDocumentCardPreviewProps = {
  getOverflowDocumentCountText: () => "",
  previewImages: [],
};
